import React from 'react';
import './impersonateBanner.scss';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const ImpersonateBanner = () => {
    const isImpersonating = localStorage.getItem('impersonating') === 'true';
    const userId = localStorage.getItem('userId');

    if (!isImpersonating) return null;

    const handleStopImpersonating = () => {
        const originalUser = localStorage.getItem('original_user');
        const originalUserId = localStorage.getItem('original_userId');
        const originalPassword = localStorage.getItem('original_password');
        const originalProjects = localStorage.getItem('original_allowed_projects');

        if (originalUser) localStorage.setItem('user', originalUser);
        else localStorage.removeItem('user');

        if (originalUserId) localStorage.setItem('userId', originalUserId);
        else localStorage.removeItem('userId');

        if (originalPassword) localStorage.setItem('password', originalPassword);
        else localStorage.removeItem('password');

        if (originalProjects) localStorage.setItem('allowed_projects', originalProjects);
        else localStorage.removeItem('allowed_projects');

        localStorage.removeItem('impersonating');
        localStorage.removeItem('original_user');
        localStorage.removeItem('original_userId');
        localStorage.removeItem('original_password');
        localStorage.removeItem('original_allowed_projects');

        window.location.href = '/dashboard';
    };

    return (
        <div className="impersonateBanner">
            <span>
                <strong>⚠️ Impersonation Mode:</strong> You are currently viewing the site as user <strong>"{userId}"</strong>
            </span>
            <button className="closeBanner" onClick={handleStopImpersonating} title="Stop Impersonating">
                <CloseRoundedIcon style={{ fontSize: '1.2rem' }} />
            </button>
        </div>
    );
};

export default ImpersonateBanner;
